/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Section_TranscriptionInputs */

const en_options_editor_section_transcription = /** @type {(inputs: Options_Editor_Section_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription`)
};

const fr_options_editor_section_transcription = /** @type {(inputs: Options_Editor_Section_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription`)
};

const de_options_editor_section_transcription = /** @type {(inputs: Options_Editor_Section_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkription`)
};

const it_options_editor_section_transcription = /** @type {(inputs: Options_Editor_Section_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascrizione`)
};

const ru_options_editor_section_transcription = /** @type {(inputs: Options_Editor_Section_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Транскрипция`)
};

const es_options_editor_section_transcription = /** @type {(inputs: Options_Editor_Section_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcripción`)
};

const zh_cn2_options_editor_section_transcription = /** @type {(inputs: Options_Editor_Section_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转录`)
};

const ja_options_editor_section_transcription = /** @type {(inputs: Options_Editor_Section_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`転写`)
};

const hi_options_editor_section_transcription = /** @type {(inputs: Options_Editor_Section_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलिपि`)
};

const pt_pt2_options_editor_section_transcription = /** @type {(inputs: Options_Editor_Section_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcrição`)
};

/**
* | output |
* | --- |
* | "Transcription" |
*
* @param {Options_Editor_Section_TranscriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_section_transcription = /** @type {((inputs?: Options_Editor_Section_TranscriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Section_TranscriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_section_transcription(inputs)
	if (locale === "de") return de_options_editor_section_transcription(inputs)
	if (locale === "it") return it_options_editor_section_transcription(inputs)
	if (locale === "ru") return ru_options_editor_section_transcription(inputs)
	if (locale === "es") return es_options_editor_section_transcription(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_section_transcription(inputs)
	if (locale === "ja") return ja_options_editor_section_transcription(inputs)
	if (locale === "hi") return hi_options_editor_section_transcription(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_section_transcription(inputs)
	return en_options_editor_section_transcription(inputs)
});